<template >
  <div class='mobile-wrapping'>

    <header>
      <div class='mobile-logo' >

        <img :src="logoUrl" class='mobile-logo-image'>

      </div>
      <div class='mobile-menu'>
        <div class='mobile-menu-item' :class="activeMenu==='home'?'mobile-menu-item-active':''"
             @click="handleClickMenuItem('home')">HOME
        </div>
        <div class='mobile-menu-item' :class="activeMenu==='aboutUs'?'mobile-menu-item-active':''"
             @click="handleClickMenuItem('aboutUs')">ABOUT US
        </div>
        <div class='mobile-menu-item' :class="activeMenu==='contactUs'?'mobile-menu-item-active':''"
             @click="handleClickMenuItem('contactUs')">CONTACT US
        </div>
      </div>
    </header>

    <div id="main">

      <div :class="'mobile-main-home ' + ' mobile-main-home-'+backgroupType " id="home">
        <div class='mobile-home-main'>

        </div>
          <div  class=" change-home-box-left">
            <i class="el-icon-arrow-left change-home-box"   @click="handleHomeLeftChange"></i>

        </div>

        <div  class="change-home-box change-home-box-right">
            <i class="el-icon-arrow-right change-home-box"   @click="handleHomeRightChange"></i>

        </div>
        <div class='mobile-home-platform'>

          <div class="mobile-home-platform-item" v-for="(platform, index) in platforms" :key="index">
                <a :href="platform.link" :target="platform.target" >
                  <el-image :src="platform.mIcon" class='mobile-home-platform-item-image'></el-image>
                </a>
          </div>

        </div>

        <div class='mobile-home-radio'>
          <div class='mobile-home-radio-item'>
              <img v-if="backgroupType ===1" :src="blackUrl" alt="" @click="handleClickRadio(1)" >
               <img v-else :src="whiteUrl" alt="" @click="handleClickRadio(1)">
          </div>
            <div class='mobile-home-radio-item'>
              <img v-if="backgroupType ===2" :src="blackUrl" alt="" @click="handleClickRadio(2)">
               <img v-else :src="whiteUrl" alt="" @click="handleClickRadio(2)">
          </div>
            <div class='mobile-home-radio-item'>
              <img v-if="backgroupType ===3" :src="blackUrl" alt="" @click="handleClickRadio(3)">
               <img v-else :src="whiteUrl" alt="" @click="handleClickRadio(3)">
          </div>

              <!-- 预加载 防止切背景闪屏 -->
              <div class='  mobile-main-home-2'></div>
              <div class='  mobile-main-home-3'></div>
        </div>

      </div>

      <div class='mobile-main-about' id="about">
        <div class='mobile-main-about-text'>
          <div>
            <h1>ABOUT US</h1>
          </div>
          <div>
            <p>
              X-Poker was developed by a group of top programmers and poker enthusiasts. our goal is to offer the best service to poker players across the world. We use cutting edge technology to make sure players can compete on a fair and secure platform. You can enjoy playing poker and have a good time with friends at the same time by creating a private club in X-Poker too!
            </p>
          </div>
          <div>
            <p>
              Come to play on X-Poker and enjoy the best poker experience in the world!
            </p>
          </div>
        </div>
        <div class='mobile-main-about-main'>
          <img :src="aboutMainUrl" class='mobile-main-about-image'>
        </div>
      </div>

      <div class='mobile-main-contact' id="contact">
        <div class='mobile-main-contact-main'>
          <img :src="contactMainUrl" class='mobile-main-contact-image'>
        </div>
        <div class='mobile-contact-email'>
          <img :src="contactEmailMainUrl" class='mobile-contact-email-image'>
          <p class='mobile-contact-email-text'>support@x-poker.net</p>
        </div>
        <div class='mobile-contact-facebook'>
          <img :src="contactFacebookMainUrl" class='mobile-contact-facebook-image'>
          <p class='mobile-contact-facebook-text'>facebook.com/xpokerglobal</p>
        </div>
      </div>

    </div>
    <footer>
      <div class="mobile-footer">
      <div class='mobile-certified'>
         <a href="https://access.gaminglabs.com/Certificate/Index?i=370" target="_blank">
            <img :src="certifiedUrl"    class='mobile-certified-image'>
         </a>
      </div>

      <div class='mobile-info'>
            <p>
                <a @click="handleJumpTo('privacyPolicy')">Privacy Policy |</a>
                <a @click="handleJumpTo('termsService')">Terms of Service </a>
                <a> </a>
                </p>
             <p> Copyright © 2019-{{ year }} X-Poker. All Rights Reserved.</p>
      </div>
      </div>
    </footer>

  </div>
</template>

<script>
import logo from '@/assets/images/home/mobile/logo.png'
import certified from '@/assets/images/home/mobile/certified.jpg'
import homeMain from '@/assets/images/home/mobile/home_main.png'
import aboutMain from '@/assets/images/home/mobile/about_us_main.png'
import contactMain from '@/assets/images/home/mobile/contact_us_main.png'
import contactEmailMain from '@/assets/images/home/mobile/contact_us_email.png'
import contactFacebookMain from '@/assets/images/home/mobile/contact_us_facebook.png'
import white from '@/assets/images/home/mobile/white_radio.png'
import black from '@/assets/images/home/mobile/black_radio.png'
import platformConfig from '@/util/platform'

export default {
  name: 'HomeIndexMobile',
  data () {
    return {
      logoUrl: logo,
      certifiedUrl: certified,
      homeMainUrl: homeMain,
      aboutMainUrl: aboutMain,
      contactMainUrl: contactMain,
      contactEmailMainUrl: contactEmailMain,
      contactFacebookMainUrl: contactFacebookMain,
      whiteUrl: white,
      blackUrl: black,
      activeMenu: 'home',
      thisFontSize: 0,
      scrollType: '',
      backgroupType: 1, // 背景类型
      intervalTime: 3000,
      platforms: [],
      thisInterval: '',
      year: new Date().getFullYear()
    }
  },
  mounted () {
    this.thisFontSize = document.documentElement.style.fontSize.replace('px', '')
    window.addEventListener('scroll', this.handleMainScroll, true)
    this.reloadInterval()
    this.platforms = platformConfig.kr.home
  },
  methods: {
    reloadInterval () {
      const _that = this
      window.clearInterval(this.thisInterval)
      this.thisInterval = window.setInterval(function () {
        if (_that.backgroupType === 3) {
          _that.backgroupType = 1
        } else {
          _that.backgroupType += 1
        }

        if (_that.intervalTime !== 3000) {
          _that.intervalTime = 3000
          _that.reloadInterval()
        }
      }, _that.intervalTime)
    },
    handleClickMenuItem (activeMenu) {
      if (this.activeMenu === activeMenu) {
        return
      }

      this.activeMenu = activeMenu
      let thisFontSize = document.documentElement.style.fontSize.replace('px', '')
      let number = 0
      switch (activeMenu) {
        case 'home': {
          number = 0

          break
        }
        case 'aboutUs': {
          number = 1
          break
        }
        case 'contactUs': {
          number = 2
          break
        }
      }

      if (number === 0) {
        this.clearUrlParams()
        document.getElementById('main').scrollTop = 0
        return
      }

      document.getElementById('main').scrollTop = ((1600 / 75) * thisFontSize * number) + (320 / 75) * thisFontSize

      this.$router.push({
        query: Object.assign({}, this.$route.query, {type: activeMenu})
      })
    },
    // 清空url参数
    clearUrlParams () {
      this.$router.push({
        query: {}
      })
    },
    mathPx (width) {
      return width
    },
    handleMainScroll (e) {
      console.log(e.srcElement.scrollTop)
      // var scrollTop = e.srcElement.scrollTop

      // if ((scrollTop > this.mathPx(200)) && (scrollTop < this.mathPx(400))) {
      //   if (this.scrollType !== 'down') {
      //     document.getElementById('main').scrollTop = this.mathPx(950)
      //     this.activeMenu = 'aboutUs'
      //     this.scrollType = 'down'
      //     this.clearTimeout()
      //   }
      // } else if ((scrollTop > this.mathPx(500)) && (scrollTop < this.mathPx(700))) {
      //   if (this.scrollType !== 'up') {
      //     document.getElementById('main').scrollTop = 0
      //     this.scrollType = 'up'
      //     this.activeMenu = 'home'
      //     this.clearTimeout()
      //   }
      // } else if ((scrollTop > this.mathPx(1200)) && (scrollTop < this.mathPx(1400))) {
      //   if (this.scrollType !== 'down') {
      //     document.getElementById('main').scrollTop = this.mathPx(1750)
      //     this.scrollType = 'down'
      //     this.activeMenu = 'contactUs'
      //     this.clearTimeout()
      //   }
      // } else if ((scrollTop > this.mathPx(1500)) && (scrollTop < this.mathPx(1600))) {
      //   if (this.scrollType !== 'up') {
      //     document.getElementById('main').scrollTop = this.mathPx(950)
      //     this.scrollType = 'up'
      //     this.activeMenu = 'aboutUs'
      //     this.clearTimeout()
      //   }
      // }

      // this.number = 0
    },
    handleJumpTo (name) {
      const { href } = this.$router.resolve({
        name: name
      })
      window.open(href, '_blank')
    },
    clearTimeout () {
      let _this = this
      setTimeout(function () {
        _this.scrollType = ''
      }, 2000)
    },
    handleClickRadio (type) {
      this.intervalTime = 10000
      console.log(this.intervalTime)
      this.reloadInterval()
      this.backgroupType = type
    },
    handleHomeLeftChange () {
      if (this.backgroupType === 1) {
        this.backgroupType = 3
      } else {
        this.backgroupType -= 1
      }
    },
    handleHomeRightChange () {
      if (this.backgroupType === 3) {
        this.backgroupType = 1
      } else {
        this.backgroupType += 1
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mobile-wrapping {
    background: url('~@/assets/images/home/mobile/backgourp_image.jpg') repeat-x;
    overflow: hidden;
    height: 100%;
    position: absolute;
    left: 0px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);

  }

  header {
    width: 750px;
    height: 120px;
    position: absolute;
    z-index: 5;
    top: 0;
    text-align: center;
  }

  .mobile-logo {
    display: inline-block;
    width: 236px;
    height: 61px;
    line-height: 61px;
    vertical-align: middle;

  }

  .mobile-logo-image {
    width: 236px;
    height: 61px;

  }

  .mobile-menu {
    display: inline-block;
    width: 442px;
    font-size: 26px;
    color: #63b8e4;
    height: 120px;
    line-height: 120px;
  }

  .mobile-menu-item {
    display: inline-block;
    margin-left: 5px;

  }

  .mobile-menu-item-active {
    color: #ceeaff;

  }

  /* no*/

  #main {

    width: 100%;
    overflow: auto;
    top: 0px;
    position: absolute;
    z-index: 1;
    bottom: 0px;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .mobile-main-home {
    height: 1650px;
    width: 750px;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center ;
    background-repeat:no-repeat;
    overflow-x: scroll;
  }

  .mobile-main-home-1{
      background-image: url('~@/assets/images/home/mobile/backgroup_1.jpg');
  }

    .mobile-main-home-2{
      background-image: url('~@/assets/images/home/mobile/backgroup_2.jpg');
  }

    .mobile-main-home-3{
      background-image: url('~@/assets/images/home/mobile/backgroup_3.jpg');
  }

  .mobile-home-main {
    width: 750px;
    z-index: 1;
    position: relative;
  }

  .mobile-home-image {
    width: 750px;
    position: absolute;
    top: 250px;
    left: 0px;
    z-index: 80;
  }

  .mobile-home-platform {
    width: 750px;
    z-index: 1;
    position: absolute;
    top: 950px;
    left: 0px;
    text-align: center;
    margin-left:60px;
  }

  .mobile-home-platform-item {
    float: left;
    margin-right:40px;
    margin-bottom:40px;

  }

  .mobile-home-platform-item-image {
    width: 300px;
    height: 100px;
  }

  .mobile-home-radio{
    width: 750px;
    z-index: 1;
    position: absolute;
    top: 1220px;
    left: 326px;
    text-align: center;

  }

  .mobile-home-radio-item {
    float: left;
    margin-right:15px;

  }

  .mobile-home-radio-item >img {
    width: 15px;

  }

  .mobile-main-about {
    height: 1200px;
    width: 750px;
    margin-top: 400px;
  }

  .mobile-main-about-text {
    height: 450px;
    width: 698px;
    text-align: left;
    padding-top: 100px;
    margin-left: 52px;
    margin-right: 52px;
  }

  .mobile-main-about-text p {
    font-size: 24px;
    color: #ffffff;
    margin-right: 0.693333rem;
  }

  .mobile-main-about-text h1 {
    font-size: 32px;
    color: #ffffff;
  }

  .mobile-main-about-main {
    margin-top: 70px;
    z-index: 1;
    position: relative;
  }

  .mobile-main-about-image {
    width: 750px;
    position: absolute;
    top: -450px;
    left: 0px;
  }

  .mobile-main-contact {
    height: 1200px;
    width: 750px;
     margin-top: 400px;
    position: relative;
  }

  .mobile-main-contact-main {
    width: 750px;
    z-index: 1;
    position: relative;
  }

  .mobile-main-contact-image {
    width: 750px;
    position: absolute;
    top: -55px;
    left: 0px;
    z-index: 80;
  }

  .mobile-contact-email {
    width: 530px;
    height: 90px;
    position: absolute;
    top: 450px;
    left: 105px;
    z-index: 1;
  }

  .mobile-contact-email-image {
    width: 530px;
    height: 90px;
  }

  .mobile-contact-email-text {

    position: relative;
    top: -95px;
    left: 4px;
    font-size: 26px;
    color: #48546a;
  }

  .mobile-contact-facebook {
    width: 530px;
    height: 90px;
    position: absolute;
    top: 580px;
    left: 105px;
    z-index: 1;
  }

  .mobile-contact-facebook-image {
    width: 530px;
    height: 90px;
  }

  .mobile-contact-facebook-text {

    position: relative;
    top: -90px;
    left: 4px;
    font-size: 26px;
    color: #ffffff;
  }

  footer {
    height: 76px;
    /* background:yellow; */
    width: 100%;
    position: absolute;
    z-index: 200;
    bottom: 0;
    text-align: center;
  }

  .mobile-certified {
    display: inline-block;
     height: 57px;
     line-height: 57px;
  }

  .mobile-certified-image {
    height: 41px;
    width: 114px;

  }

  .mobile-info {
    height: 57px;
    line-height: 12px;
    font-size: 16px;
    margin-left: 18px;
    text-align: left;

    display: inline-block;
    color: #d2d7e5;
    width: 600px;
       overflow: hidden;/*超出部分隐藏*/
            white-space: nowrap;/*不换行*/

  }
  .change-home-box{
   background-color:transparent;
   border-color:transparent;
   font-size: 74px;
   color: white;
    opacity: 0.6;
  }

    .change-home-box-left{
      position: absolute;
      top:40%;
      left:10%;
      transform: translate(-50%,-50%);
  }

.change-home-box-right{
      position: absolute;
      top:40%;
      right:10%;
      transform: translate(50%,-50%);
  }

</style>



// WEBPACK FOOTER //
// src/views/home/lang/kr/mobile.vue